import styled, { css } from 'styled-components';
import { Button, ButtonSize, ButtonAppearance } from '@bechtel/gds';

export const CloneContainerStyled = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 20% 50% 30%;
    background-color: ${theme.colors.grey[100]};
    padding-top: ${theme.spacings[300]};
    padding-bottom: ${theme.spacings[300]};
    border-bottom: 1px solid ${theme.colors.grey[300]};
  `}
`;

export const RepeatButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
  appearance: ButtonAppearance.TERTIARY,
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.black};
    padding-left: ${theme.spacings[450]};
    padding-right: ${theme.spacings[450]};
    margin-left: ${theme.spacings[450]};
    width: auto;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    &:hover {
      background-color: ${theme.colors.white};
    }
  `}
`;
